import { render } from "./cell_color.vue?vue&type=template&id=297a1ad9"
import script from "./cell_color.vue?vue&type=script&lang=ts"
export * from "./cell_color.vue?vue&type=script&lang=ts"
script.render = render

export default script